import apiService from './api';

class CatalogService {
    // Obtener productos con filtros y paginación
    async getProducts(filters = {}) {
        try {
            const params = {
                page: filters.page || 1,
                limit: filters.limit || 20,
                search: filters.search || '',
                categoria: filters.categoria || '',
                marca: filters.marca || '',
                precio_min: filters.precio_min || '',
                precio_max: filters.precio_max || '',
                ordenar: filters.ordenar || 'relevancia',
                disponible: filters.disponible || '',
                oferta: filters.oferta || '',
                procesador: filters.procesador || '',
                memoria_ram: filters.memoria_ram || '',
                almacenamiento: filters.almacenamiento || '',
                tarjeta_grafica: filters.tarjeta_grafica || ''
            };

            // Remover parámetros vacíos
            Object.keys(params).forEach(key => {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                    delete params[key];
                }
            });

            return await apiService.get('/catalog/products', params);
        } catch (error) {
            throw new Error(error.message || 'Error al obtener productos');
        }
    }

    // Obtener producto por ID
    async getProductById(id) {
        try {
            return await apiService.get(`/catalog/product/${id}`);
        } catch (error) {
            throw new Error(error.message || 'Error al obtener producto');
        }
    }

    // Obtener datos para la página de inicio (productos destacados y populares)
    async getHomeData() {
        try {
            return await apiService.get('/catalog/home');
        } catch (error) {
            throw new Error(error.message || 'Error al obtener datos de inicio');
        }
    }

    // Obtener productos relacionados - TEMPORALMENTE DESHABILITADO
    // async getRelatedProducts(productId, limit = 8) {
    //     try {
    //         return await apiService.get(`/catalog/products/${productId}/related`, { limit });
    //     } catch (error) {
    //         throw new Error(error.message || 'Error al obtener productos relacionados');
    //     }
    // }

    // Obtener productos destacados
    async getFeaturedProducts(limit = 12) {
        try {
            return await apiService.get('/catalog/products/featured', { limit });
        } catch (error) {
            throw new Error(error.message || 'Error al obtener productos destacados');
        }
    }

    // Obtener productos en oferta
    async getProductsOnSale(limit = 12) {
        try {
            return await apiService.get('/catalog/products/on-sale', { limit });
        } catch (error) {
            throw new Error(error.message || 'Error al obtener productos en oferta');
        }
    }

    // Obtener categorías
    async getCategories() {
        try {
            return await apiService.get('/catalog/categories');
        } catch (error) {
            throw new Error(error.message || 'Error al obtener categorías');
        }
    }

    // Obtener categoría por ID
    async getCategoryById(id) {
        try {
            return await apiService.get(`/catalog/categories/${id}`);
        } catch (error) {
            throw new Error(error.message || 'Error al obtener categoría');
        }
    }

    // Obtener marcas
    async getBrands() {
        try {
            return await apiService.get('/catalog/brands');
        } catch (error) {
            throw new Error(error.message || 'Error al obtener marcas');
        }
    }

    // Obtener marca por ID
    async getBrandById(id) {
        try {
            return await apiService.get(`/catalog/brands/${id}`);
        } catch (error) {
            throw new Error(error.message || 'Error al obtener marca');
        }
    }

    // Obtener filtros disponibles
    async getAvailableFilters() {
        try {
            return await apiService.get('/catalog/filters');
        } catch (error) {
            throw new Error(error.message || 'Error al obtener filtros');
        }
    }

    // Buscar productos
    async searchProducts(query, filters = {}) {
        try {
            const params = {
                q: query,
                page: filters.page || 1,
                limit: filters.limit || 20,
                categoria: filters.categoria || '',
                marca: filters.marca || '',
                precio_min: filters.precio_min || '',
                precio_max: filters.precio_max || '',
                ordenar: filters.ordenar || 'relevancia'
            };

            // Remover parámetros vacíos
            Object.keys(params).forEach(key => {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                    delete params[key];
                }
            });

            return await apiService.get('/catalog/search', params);
        } catch (error) {
            throw new Error(error.message || 'Error en la búsqueda');
        }
    }

    // Obtener sugerencias de búsqueda
    async getSearchSuggestions(query) {
        try {
            return await apiService.get('/catalog/search/suggestions', { q: query });
        } catch (error) {
            throw new Error(error.message || 'Error al obtener sugerencias');
        }
    }

    // Obtener estadísticas del catálogo
    async getCatalogStats() {
        try {
            return await apiService.get('/catalog/stats');
        } catch (error) {
            throw new Error(error.message || 'Error al obtener estadísticas');
        }
    }

    // Obtener productos por categoría
    async getProductsByCategory(categoryId, filters = {}) {
        try {
            const params = {
                page: filters.page || 1,
                limit: filters.limit || 20,
                marca: filters.marca || '',
                precio_min: filters.precio_min || '',
                precio_max: filters.precio_max || '',
                ordenar: filters.ordenar || 'relevancia'
            };

            // Remover parámetros vacíos
            Object.keys(params).forEach(key => {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                    delete params[key];
                }
            });

            return await apiService.get(`/catalog/categories/${categoryId}/products`, params);
        } catch (error) {
            throw new Error(error.message || 'Error al obtener productos de la categoría');
        }
    }

    // Obtener productos por marca
    async getProductsByBrand(brandId, filters = {}) {
        try {
            const params = {
                page: filters.page || 1,
                limit: filters.limit || 20,
                categoria: filters.categoria || '',
                precio_min: filters.precio_min || '',
                precio_max: filters.precio_max || '',
                ordenar: filters.ordenar || 'relevancia'
            };

            // Remover parámetros vacíos
            Object.keys(params).forEach(key => {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                    delete params[key];
                }
            });

            return await apiService.get(`/catalog/brands/${brandId}/products`, params);
        } catch (error) {
            throw new Error(error.message || 'Error al obtener productos de la marca');
        }
    }

    // Obtener rangos de precios
    async getPriceRanges() {
        try {
            return await apiService.get('/catalog/price-ranges');
        } catch (error) {
            throw new Error(error.message || 'Error al obtener rangos de precios');
        }
    }

    // Verificar disponibilidad de producto
    async checkProductAvailability(productId) {
        try {
            return await apiService.get(`/catalog/products/${productId}/availability`);
        } catch (error) {
            throw new Error(error.message || 'Error al verificar disponibilidad');
        }
    }

    // Obtener especificaciones de producto
    async getProductSpecifications(productId) {
        try {
            return await apiService.get(`/catalog/products/${productId}/specifications`);
        } catch (error) {
            throw new Error(error.message || 'Error al obtener especificaciones');
        }
    }

    // Obtener imágenes de producto
    async getProductImages(productId) {
        try {
            return await apiService.get(`/catalog/products/${productId}/images`);
        } catch (error) {
            throw new Error(error.message || 'Error al obtener imágenes');
        }
    }

    // ========== NUEVOS ENDPOINTS PARA FILTROS ==========

    // Obtener canales disponibles
    async getChannels() {
        try {
            return await apiService.get('/catalog/channels');
        } catch (error) {
            throw new Error(error.message || 'Error al obtener canales');
        }
    }

    // Obtener subcategorías por categoría
    async getSubcategories(categoryId) {
        try {
            return await apiService.get(`/catalog/subcategories?id_categoria=${categoryId}`);
        } catch (error) {
            throw new Error(error.message || 'Error al obtener subcategorías');
        }
    }

    // Obtener marcas por categoría
    async getBrandsByCategory(categoryId) {
        try {
            return await apiService.get(`/catalog/brands?id_categoria=${categoryId}`);
        } catch (error) {
            throw new Error(error.message || 'Error al obtener marcas por categoría');
        }
    }

    // Obtener conceptos por categoría
    async getConceptsByCategory(categoryId) {
        try {
            return await apiService.get(`/catalog/concepts?id_categoria=${categoryId}`);
        } catch (error) {
            throw new Error(error.message || 'Error al obtener conceptos por categoría');
        }
    }

    // Obtener todos los conceptos
    async getConcepts() {
        try {
            return await apiService.get('/catalog/concepts');
        } catch (error) {
            throw new Error(error.message || 'Error al obtener conceptos');
        }
    }

    // Obtener líneas de marca por marca
    async getBrandLinesByBrand(brandId) {
        try {
            return await apiService.get(`/catalog/brand-lines?id_marca=${brandId}`);
        } catch (error) {
            throw new Error(error.message || 'Error al obtener líneas de marca');
        }
    }
}

// Instancia singleton del servicio de catálogo
const catalogService = new CatalogService();

export default catalogService;
